const KEY = "KITCHEN_PENDING_COUNT";

export function setKitchenCount(count) {
  localStorage.setItem(KEY, String(count));
}

export function getKitchenCount() {
  const v = localStorage.getItem(KEY);
  return v ? parseInt(v, 10) : 0;
}

export function clearKitchenCount() {
  localStorage.removeItem(KEY);
}

